/**
 * Faixas de controle POR CANAL — GUPM-270.
 *
 * Régua do instrumento multi-canal (hoje só o tiltímetro, que tem carta em
 * `eixo_a`/`eixo_b` e nunca em `canal is null`). Três telas precisam dela — o
 * Dashboard e o Mapa para as colunas ±5,00/±7,50/±15,00 da tabela de tiltímetros, e
 * o M6 para as linhas de referência do gráfico —, então mora num hook só: mesma
 * `queryKey`, mesmo cache, uma requisição por sessão em vez de três.
 *
 * São poucas dezenas de linhas (2 por tiltímetro ativo), sem polling: carta muda
 * por carga administrativa, não em tempo de operação.
 */
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';
import type { FaixaCanal } from '@/domain/instrumentos/tilt';

export function useFaixasCanal(): { faixasCanal: FaixaCanal[]; error: Error | null } {
  const { instrumentacao } = useDataSources();
  const { data = [], error } = useQuery({
    queryKey: ['faixas', 'canal'],
    queryFn: () => instrumentacao.listFaixasCanal(),
  });

  // O log mora AQUI, não em cada chamador: falha nesta query é indistinguível de
  // "carta ainda não carregada" na tela — nos dois casos o tiltímetro aparece
  // `SEM_FAIXA`. O M6 trata o erro como bloqueante (lá a régua é o conteúdo da tela);
  // o Dashboard e o Mapa seguem renderizando o resto, mas não podem engolir a falha
  // em silêncio, senão o RT lê "a carta não chegou" onde houve erro de rede ou de RLS.
  useEffect(() => {
    if (error) console.warn('[faixas] carta por canal indisponível', { err: error });
  }, [error]);

  return { faixasCanal: data, error };
}
